import React from 'react'
import StyleInjector from '../infra/StyleInjector'

const getMemberLetter = displayName => {
  return displayName[0].toUpperCase()
}

const getMemberColor = (color, overrideColor) => {
  return overrideColor || color
}

const getBackgroundAnimateKeyframe = (name, srcColor, destColor) => {
  const keyframes =
    `@-webkit-keyframes ${name} {
        0% {background-color: ${srcColor}}
        50% {background-color: ${destColor}}
        100% {background-color: ${srcColor}}
    }`
 return keyframes;
}

const getAnimateStyle = (animate, id, srcColor, destColor) => {
  if (!animate){
    return {}
  } else {
     //whitespaces will be taken literal in css
    const cleanId = id.replace(/[^a-zA-Z0-9]/g, '')
    const name = `bg-color-${cleanId}`
    const keyframes = getBackgroundAnimateKeyframe(name, srcColor, destColor)
    StyleInjector.inject(keyframes)

    return styles.animateStyle(name, '2s', 'infinite')
  }
}

class FourMembersRoomAvatar extends React.Component {

  render() {
    const members = this.props.members
    const size = this.props.size
    const shiftFactor = size/12

    const color1 = getMemberColor(members[0].color, this.props.overrideColor)
    const color2 = getMemberColor(members[1].color, this.props.overrideColor)
    const color3 = getMemberColor(members[2].color, this.props.overrideColor)
    const color4 = getMemberColor(members[3].color, this.props.overrideColor)

    const animateStyle1 = getAnimateStyle(
                            this.props.animate,
                            members[0].userId,
                            members[0].color,
                            this.props.overrideColor
                          )
    const animateStyle2 = getAnimateStyle(
                            this.props.animate,
                            members[1].userId,
                            members[1].color,
                            this.props.overrideColor
                          )
    const animateStyle3 = getAnimateStyle(
                            this.props.animate,
                            members[2].userId,
                            members[2].color,
                            this.props.overrideColor
                          )
    const animateStyle4 = getAnimateStyle(
                            this.props.animate,
                            members[3].userId,
                            members[3].color,
                            this.props.overrideColor
                          )
    return (
      <div style={this.props.style}>
        <div style={styles.row}>
          <div style={{ ...styles.quarter(size / 2, color1), ...styles.topLeft(size / 2), ...animateStyle1 }}>
            <div style={styles.smallLetter(size, shiftFactor, shiftFactor)}>
              { getMemberLetter(members[0].displayName) }
            </div>
          </div>
          <div style={{ ...styles.quarter(size / 2, color2), ...styles.topRight(size / 2), ...animateStyle2 }}>
            <div style={styles.smallLetter(size, -shiftFactor, shiftFactor)}>
              { getMemberLetter(members[1].displayName) }
            </div>
          </div>
        </div>
        <div style={styles.row}>
          <div style={{ ...styles.quarter(size / 2, color3), ...styles.bottomLeft(size / 2), ...animateStyle3 }}>
            <div style={styles.smallLetter(size, shiftFactor, -shiftFactor)}>
              { getMemberLetter(members[2].displayName) }
            </div>
          </div>
          <div style={{ ...styles.quarter(size / 2, color4), ...styles.bottomRight(size / 2), ...animateStyle4 }}>
            <div style={styles.smallLetter(size, -shiftFactor, -shiftFactor)}>
              { getMemberLetter(members[3].displayName) }
            </div>
          </div>
        </div>
      </div>
    )
  }

}

class ThreeMembersRoomAvatar extends React.Component {

  render() {
    const members = this.props.members
    const size = this.props.size
    const shiftFactor = size/12

    const color1 = getMemberColor(members[0].color, this.props.overrideColor)
    const color2 = getMemberColor(members[1].color, this.props.overrideColor)
    const color3 = getMemberColor(members[2].color, this.props.overrideColor)

    const animateStyle1 = getAnimateStyle(
                            this.props.animate,
                            members[0].userId,
                            members[0].color,
                            this.props.overrideColor
                          )
    const animateStyle2 = getAnimateStyle(
                            this.props.animate,
                            members[1].userId,
                            members[1].color,
                            this.props.overrideColor
                          )
    const animateStyle3 = getAnimateStyle(
                            this.props.animate,
                            members[2].userId,
                            members[2].color,
                            this.props.overrideColor
                          )
    return (
      <div style={this.props.style}>
        <div style={styles.row}>
          <div style={{ ...styles.semiCircle(size, color1), ...styles.left(size), ...animateStyle1 }}>
            <div style={styles.mediumLetter(size, shiftFactor)}>
              { getMemberLetter(members[0].displayName) }
            </div>
          </div>
          <div style={styles.column}>
            <div style={{ ...styles.quarter(size / 2, color2), ...styles.topRight(size / 2), ...animateStyle2 }}>
              <div style={styles.smallLetter(size, -shiftFactor, shiftFactor)}>
                { getMemberLetter(members[1].displayName) }
              </div>
            </div>
            <div style={{ ...styles.quarter(size / 2, color3), ...styles.bottomRight(size / 2), ...animateStyle3 }}>
              <div style={styles.smallLetter(size, -shiftFactor, -shiftFactor)}>
                { getMemberLetter(members[2].displayName) }
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

}

class TwoMembersRoomAvatar extends React.Component {

  render() {
    const members = this.props.members
    const size = this.props.size
    const shiftFactor = size/12

    const color1 = getMemberColor(members[0].color, this.props.overrideColor)
    const color2 = getMemberColor(members[1].color, this.props.overrideColor)

    const animateStyle1 = getAnimateStyle(
                            this.props.animate,
                            members[0].userId,
                            members[0].color,
                            this.props.overrideColor
                          )
    const animateStyle2 = getAnimateStyle(
                            this.props.animate,
                            members[1].userId,
                            members[1].color,
                            this.props.overrideColor
                          )
    return (
      <div style={this.props.style}>
        <div style={styles.row}>
          <div style={{ ...styles.semiCircle(size, color1), ...styles.left(size), ...animateStyle1 }}>
            <div style={styles.mediumLetter(size, shiftFactor)}>
              { getMemberLetter(members[0].displayName) }
            </div>
          </div>
          <div style={{ ...styles.semiCircle(size, color2), ...styles.right(size), ...animateStyle2 }}>
            <div style={styles.mediumLetter(size, -shiftFactor)}>
              { getMemberLetter(members[1].displayName) }
            </div>
          </div>
        </div>
      </div>
    )
  }

}

class OneMemberRoomAvatar extends React.Component {

  render() {
    const members = this.props.members
    const size = this.props.size

    const color1 = getMemberColor(members[0].color, this.props.overrideColor)
    const animateStyle1 = getAnimateStyle(
                            this.props.animate,
                            members[0].userId,
                            members[0].color,
                            this.props.overrideColor
                          )
    return (
      <div style={this.props.style}>
        <div style={styles.row}>
          <div style={{ ...styles.circle(size, color1), ...styles.left(size), ...animateStyle1 }}>
            <div style={styles.bigLetter(size)}>
              { getMemberLetter(members[0].displayName) }
            </div>
          </div>
        </div>
      </div>
    )
  }

}

export default class ChatRoomAvatar extends React.Component {

  render() {
    const members = this.props.members
    if (!members || !members.length) {
      return null
    }
    const size = this.props.size || 50
    const style = this.props.style
    const overrideColor = this.props.overrideColor
    const animate = this.props.animate

    if (members.length >= 4) {
      return <FourMembersRoomAvatar
                style={style}
                size={size}
                members={members}
                overrideColor={overrideColor}
                animate={animate}/>
    }
    if (members.length === 3) {
      return <ThreeMembersRoomAvatar
                style={style}
                size={size}
                members={members}
                overrideColor={overrideColor}
                animate={animate}/>
    }
    if (members.length === 2) {
      return <TwoMembersRoomAvatar
                style={style}
                size={size}
                members={members}
                overrideColor={overrideColor}
                animate={animate}/>
    }
    return <OneMemberRoomAvatar
                style={style}
                size={size}
                members={members}
                overrideColor={overrideColor}
                animate={animate}/>
  }

}

const styles = {

  quarter: (size, backgroundColor) => ({
    backgroundColor,
    display: 'block',
    height: size,
    width: size
  }),

  semiCircle: (size, backgroundColor) => ({
    backgroundColor,
    display: 'block',
    height: size,
    width: size / 2
  }),

  circle: (size, backgroundColor) => ({
    backgroundColor,
    display: 'block',
    height: size,
    width: size,
    borderTopLeftRadius: size,
    borderBottomLeftRadius: size,
    borderTopRightRadius: size,
    borderBottomRightRadius: size
  }),

  topLeft: size => ({
    borderTopLeftRadius: size
  }),

  left: size => ({
    borderTopLeftRadius: size,
    borderBottomLeftRadius: size
  }),

  topRight: size => ({
    borderTopRightRadius: size
  }),

  right: size => ({
    borderTopRightRadius: size,
    borderBottomRightRadius: size
  }),

  bottomLeft: size => ({
    borderBottomLeftRadius: size
  }),

  bottomRight: size => ({
    borderBottomRightRadius: size
  }),

  row: {
    display: 'flex',
    flexDirection: 'row'
  },

  column: {
    display: 'flex',
    flexDirection: 'column'
  },

  smallLetter: (size, shiftHorizontal, shiftVertical) => ({
    color: 'white',
    fontWeight: '300',
    fontSize: size/4,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: size/2 + shiftHorizontal,
    height: size/2 + shiftVertical
  }),

  mediumLetter: (size, shiftHorizontal) => ({
    color: 'white',
    fontWeight: '300',
    fontSize: size/3,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: size/2 + shiftHorizontal,
    height: size
  }),

  bigLetter: (size, shiftHorizontal) => ({
    color: 'white',
    fontWeight: '300',
    fontSize: size/2,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: size,
    height: size
  }),

  animateStyle: (animationName, duration, iteration) => ({
    animationName: animationName,
    animationDuration: duration,
    animationIterationCount: iteration,
  })

}



// WEBPACK FOOTER //
// ./src/chat/ChatRoomAvatar.js